import React from 'react';

const title = () => {
  return (
    <div>
      <h2 className='title is-1 has-text-centered is-family-sans-serif '>Find The Hottest Albums</h2>
    </div>
  );
}
export default title